import {useAppSelector} from "./redux";

export function useGetFavoriteIds(): number[]{
    const { articles } = useAppSelector(state => state.auth);

    return articles?.map(item => item.value)?.flat() || []
}